import { render, staticRenderFns } from "./alert.vue?vue&type=template&id=96386532&scoped=true"
import script from "./js/alert.js?vue&type=script&lang=js&external"
export * from "./js/alert.js?vue&type=script&lang=js&external"
import style0 from "./alert.vue?vue&type=style&index=0&id=96386532&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96386532",
  null
  
)

export default component.exports